<template>
  <v-dialog
    v-model="dialog"
    width="600"
  >
    <!-- <anular-item :movilidad="movilidad" v-if="movilidad.id_tipo_justificacion === 1 "/>   -->
     <aprobar-movilidad-item :movilidad="movilidad" v-if="movilidad.id_tipo_justificacion === 7 || movilidad.id_tipo_justificacion === 1 || movilidad.id_tipo_justificacion === 14"/>
    <aprobar-retiro :movilidad="movilidad" v-if="movilidad.id_tipo_justificacion === 5 || movilidad.id_tipo_justificacion === 6 || movilidad.id_tipo_justificacion === 10" />
    <!-- <aprobar-cambio-item :movilidad="movilidad" v-if="movilidad.id_tipo_justificacion === 1 "/> -->
    <aprobar-comision-servicio :movilidad="movilidad" v-if="movilidad.id_tipo_justificacion === 11 || movilidad.id_tipo_justificacion === 2 " />
    <aprobar-reestructuracion :movilidad="movilidad" v-if="movilidad.id_tipo_justificacion == 15 " />
  </v-dialog>
</template>

<script>
import AprobarCambioItem from '@/components/admin/persona/components/AprobarCambioItem'
import AprobarMovilidadItem from '../components/AprobarMovilidadItem'
import AprobarRetiro from '../components/AprobarRetiro'
import AprobarComisionServicio from '../components/AprobarComisionServicio'
import AprobarReestructuracion from '../components/AprobarReestructuracion.vue'

export default {
  components: {
    AprobarCambioItem,
    AprobarRetiro,
    AprobarComisionServicio,
    AprobarMovilidadItem,
    AprobarReestructuracion
  },
  data () {
    return {
      dialog: false,
      movilidad: {
        funcionario: {}
      }
    }
  },
  mounted () {
    this.$bus.$on('openDialogAprobarTipoMovilidad', item => {
      this.movilidad.id_movilidad_actual = item.id;
      this.movilidad = item
      this.dialog = true
    })
    this.$bus.$on('closeDialogAprobar', () => {
      this.close()
    })

    this.$bus.$on('closeDialogAprobarReestructuracion', () => {
      this.close()
    })
  },
  methods: {
    close () {
      this.dialog = false
      this.movilidad = {
        funcionario: {}
      }
      this.$bus.$emit('closeDialogMovilidad')
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/admin/movilidad/dialogs/AprobarTipoMovilidad.vue